import type { TourConfig } from '../types';

export const dashboardPageTour: TourConfig = {
  pageId: 'dashboard',
  pageName: 'Dashboard',
  portalId: 'crm',
  steps: [
    {
      element: '[data-tour="dashboard-stats"]',
      title: 'Overview Stats',
      intro:
        'Your key metrics at a glance: referral sources, projects, quarterly closings, and pending commissions.',
      platform: 'both',
    },
    {
      element: '[data-tour="quick-actions"]',
      title: 'Quick Actions',
      intro:
        'Jump to common tasks: add a referral source, view your projects, or generate a quarterly report.',
      platform: 'both',
    },
    {
      element: '[data-tour="recent-activity"]',
      title: 'Recent Activity',
      intro:
        'A live feed of recent actions across the CRM: new companies, project updates, and commission changes.',
      platform: 'both',
    },
    {
      element: '[data-tour="crm-sidebar"]',
      title: 'Navigation',
      intro:
        'Use the sidebar to navigate between Dashboard, Companies, Projects, and Reports. Admin sections appear if you have access.',
      platform: 'desktop',
    },
  ],
};
